function getCartProgress(totalPrice, saleThreshold) {


  if (totalPrice < saleThreshold) {
    return totalPrice * 100 / saleThreshold
  }

  return 100
}

export { getCartProgress }
